import { gql } from '@apollo/client'

const ShopCategoryFragment: any = gql`
  fragment ShopCategoryData on ShopCategory {
    id
    slug
    name
    image
  }
`

const ShopDeliveryFragment: any = gql`
  fragment ShopDeliveryData on ShopDeliveryOption {
    id
    name
    amount
    confirmation_email
    confirmation_email_cc
  }
`

const ShopOrderFragment: any = gql`
  fragment ShopOrderData on ShopOrder {
    id
    roi_id
    intent_id
    transaction_id
    subtotal
    total_vat
    delivery_cost
    total
    status
    basket
    user
    location_id
    delivery_address
    created_at
    updated_at
  }
`

const ShopSizeGuideFragment: any = gql`
  fragment ShopSizeGuideData on ShopSizeGuide {
    id
    roi_id
    name
    url
    file_ext
  }
`

const ShopVariantFragment: any = gql`
  fragment ShopVariantData on ShopVariant {
    id
    name
    slug
  }
`

const ShopVariantVariationFragment: any = gql`
  fragment ShopVariantVariationData on ShopVariantVariation {
    id
    variant_id
    variant_type
    name
    slug
  }
`

const ShopProductFragment: any = gql`
  fragment ShopProductData on ShopProduct {
    id
    unique_id
    roi_id
    category_id
    delivery_option_id
    size_guide_id
    published
    name
    description
    price
    vat
    config
    size_guide
    images
    variants
    basket
    created_at
    updated_at
  }
`

const ShopProductImageFragment: any = gql`
  fragment ShopProductImageData on ShopProductImage {
    id
    product_id
    type
    file_type
    file_ext
    name
    url
    created_at
  }
`

const LinksFragment: any = gql`
  fragment LinksData on PaginatorLinks {
    totalResults
    totalPages
    page
    perPage
    prevPage
    nextPage
  }
`

export const GET_SHOP_CATEGORIES: any = gql`
  query ShopCategories {
    shopCategories {
      ...ShopCategoryData
    }
  }
  ${ ShopCategoryFragment }
`

export const CREATE_SHOP_CATEGORY: any = gql`
  mutation CreateShopCategory($input: MutationCreateShopCategoryInput!) {
    createShopCategory(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopCategorySuccess {
        data {
          ...ShopCategoryData
        }
      }
    }
  }
  ${ ShopCategoryFragment }
`

export const UPDATE_SHOP_CATEGORY: any = gql`
  mutation UpdateShopCategory($input: MutationUpdateShopCategoryInput!) {
    updateShopCategory(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopCategorySuccess {
        data {
          ...ShopCategoryData
        }
      }
    }
  }
  ${ ShopCategoryFragment }
`

export const GET_SHOP_DELIVERY_OPTIONS: any = gql`
  query ShopDeliveryOptions {
    shopDeliveryOptions {
      ...ShopDeliveryData
    }
  }
  ${ ShopDeliveryFragment }
`

export const GET_SHOP_DELIVERY_OPTION_BY_ID: any = gql`
  query ShopDeliveryOptionById($input: QueryShopDeliveryOptionByIdInput!) {
    shopDeliveryOptionById(input: $input) {
      ...ShopDeliveryData
    }
  }
  ${ ShopDeliveryFragment }
`

export const CREATE_SHOP_DELIVERY_OPTION: any = gql`
  mutation CreateShopDeliveryOption($input: MutationCreateShopDeliveryOptionInput!) {
    createShopDeliveryOption(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopDeliveryOptionSuccess {
        data {
          ...ShopDeliveryData
        }
      }
    }
  }
  ${ ShopDeliveryFragment }
`

export const UPDATE_SHOP_DELIVERY_OPTION: any = gql`
  mutation UpdateShopDeliveryOption($input: MutationUpdateShopDeliveryOptionInput!) {
    updateShopDeliveryOption(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopDeliveryOptionSuccess {
        data {
          ...ShopDeliveryData
        }
      }
    }
  }
  ${ ShopDeliveryFragment }
`

export const GET_SHOP_SIZE_GUIDES: any = gql`
  query ShopSizeGuides {
    shopSizeGuides {
      ...ShopSizeGuideData
    }
  }
  ${ ShopSizeGuideFragment }
`

export const GET_SHOP_SIZE_GUIDE_BY_ID: any = gql`
  query ShopSizeGuideById($input: QueryShopSizeGuideByIdInput!) {
    shopSizeGuideById(input: $input) {
      ...ShopSizeGuideData
    }
  }
  ${ ShopSizeGuideFragment }
`

export const CREATE_SHOP_SIZE_GUIDE: any = gql`
  mutation CreateShopSizeGuide($input: MutationCreateShopSizeGuideInput!) {
    createShopSizeGuide(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopSizeGuideSuccess {
        data {
          ...ShopSizeGuideData
        }
      }
    }
  }
  ${ ShopSizeGuideFragment }
`

export const UPDATE_SHOP_SIZE_GUIDE: any = gql`
  mutation UpdateShopSizeGuide($input: MutationUpdateShopSizeGuideInput!) {
    updateShopSizeGuide(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopSizeGuideSuccess {
        data {
          ...ShopSizeGuideData
        }
      }
    }
  }
  ${ ShopSizeGuideFragment }
`

export const DELETE_SIZE_GUIDE: any = gql`
  mutation DeleteSizeGuide($input: MutationDeleteSizeGuideInput!) {
    deleteSizeGuide(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteSizeGuideSuccess {
        data
      }
    }
  }
`

export const DELETE_SIZE_GUIDE_FILE: any = gql`
  mutation DeleteSizeGuideFile($input: MutationDeleteSizeGuideFileInput!) {
    deleteSizeGuideFile(input: $input)
  }
`

export const GET_SHOP_VARIANTS: any = gql`
  query ShopVariants {
    shopVariants {
      ...ShopVariantData
    }
  }
  ${ ShopVariantFragment }
`

export const CREATE_SHOP_VARIANT: any = gql`
  mutation CreateShopVariant($input: MutationCreateShopVariantInput!) {
    createShopVariant(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopVariantSuccess {
        data {
          ...ShopVariantData
        }
      }
    }
  }
  ${ ShopVariantFragment }
`

export const UPDATE_SHOP_VARIANT: any = gql`
  mutation UpdateShopVariant($input: MutationUpdateShopVariantInput!) {
    updateShopVariant(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopVariantSuccess {
        data {
          ...ShopVariantData
        }
      }
    }
  }
  ${ ShopVariantFragment }
`

export const GET_SHOP_VARIANTS_VARIATIONS: any = gql`
  query ShopVariantsVariations {
    shopVariantsVariations {
      ...ShopVariantVariationData
    }
  }
  ${ ShopVariantVariationFragment }
`

export const CREATE_SHOP_VARIANT_VARIATION: any = gql`
  mutation CreateShopVariantVariation($input: MutationCreateShopVariantVariationInput!) {
    createShopVariantVariation(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopVariantVariationSuccess {
        data {
          ...ShopVariantVariationData
        }
      }
    }
  }
  ${ ShopVariantVariationFragment }
`

export const UPDATE_SHOP_VARIANT_VARIATION: any = gql`
  mutation UpdateShopVariantVariation($input: MutationUpdateShopVariantVariationInput!) {
    updateShopVariantVariation(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopVariantVariationSuccess {
        data {
          ...ShopVariantVariationData
        }
      }
    }
  }
  ${ ShopVariantVariationFragment }
`

export const GET_SHOP_PRODUCTS_LIST: any = gql`
  query ShopProductsList($input: QueryShopProductsListInput!) {
    shopProductsList(input: $input) {
      data {
        ...ShopProductData
      }
      links {
        ...LinksData
      }
    }
  }
  ${ ShopProductFragment }
  ${ LinksFragment }
`

export const GET_SHOP_PRODUCT_BY_ID: any = gql`
  query ShopProductById($input: QueryShopProductByIdInput!) {
    shopProductById(input: $input) {
      ...ShopProductData
    }
  }
  ${ ShopProductFragment }
`

export const CREATE_SHOP_PRODUCT: any = gql`
  mutation CreateShopProduct($input: MutationCreateShopProductInput!) {
    createShopProduct(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopProductSuccess {
        data {
          ...ShopProductData
        }
      }
    }
  }
  ${ ShopProductFragment }
`

export const UPDATE_SHOP_PRODUCT: any = gql`
  mutation UpdateShopProduct($input: MutationUpdateShopProductInput!) {
    updateShopProduct(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopProductSuccess {
        data
      }
    }
  }
`

export const CREATE_SHOP_PRODUCT_IMAGE: any = gql`
  mutation CreateShopProductImage($input: MutationCreateShopProductImageInput!) {
    createShopProductImage(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopProductImageSuccess {
        data {
          ...ShopProductImageData
        }
      }
    }
  }
  ${ ShopProductImageFragment }
`

export const DELETE_SHOP_PRODUCT_IMAGE: any = gql`
  mutation DeleteShopProductImage($input: MutationDeleteShopProductImageInput!) {
    deleteShopProductImage(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteShopProductImageSuccess {
        data
      }
    }
  }
`

export const UPDATE_SHOP_PRODUCT_VARIANTS: any = gql`
  mutation UpdateShopProductVariants($input: MutationUpdateShopProductVariantsInput!) {
    updateShopProductVariants(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopProductVariantsSuccess {
        data
      }
    }
  }
`

export const DELETE_SHOP_PRODUCT_VARIANTS: any = gql`
  mutation DeleteShopProductVariants($input: MutationDeleteShopProductVariantsInput!) {
    deleteShopProductVariants(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteShopProductVariantsSuccess {
        data
      }
    }
  }
`

export const GET_PRODUCT_SALES_REPORT: any = gql`
  query GetProductSalesReport {
    productSalesReport {
      month
      productName
      quantity
    }
  }
`

export const GET_SHOP_ORDERS_TO_CSV: any = gql`
  query ShopOrdersToCSV($input: QueryShopOrdersToCSVInput!) {
    shopOrdersToCSV(input: $input) {
      ...ShopOrderData
    }
  }
  ${ ShopOrderFragment }
`

export const GET_MMA_TO_CSV: any = gql`
  query GetMMAToCSV($input: QueryGetMMAToCSVInput!) {
    getMMAToCSV(input: $input) {
      ...ShopOrderData
    }
  }
  ${ ShopOrderFragment }
`

export const GET_SHOP_ORDERS: any = gql`
  query ShopOrdersList($input: QueryShopOrdersListInput!) {
    shopOrdersList(input: $input) {
      data {
        ...ShopOrderData
      }
      links {
        ...LinksData
      }
    }
  }
  ${ ShopOrderFragment }
  ${ LinksFragment }
`

export const GET_SHOP_ORDER_BY_ID: any = gql`
  query ShopOrderById($input: QueryShopOrderByIdInput!) {
    shopOrderById(input: $input) {
      ...ShopOrderData
    }
  }
  ${ ShopOrderFragment }
`

export const CREATE_SHOP_ORDER: any = gql`
  mutation CreateShopOrder($input: MutationCreateShopOrderInput!) {
    createShopOrder(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationCreateShopOrderSuccess {
        data {
          ...ShopOrderData
        }
      }
    }
  }
  ${ ShopOrderFragment }
`

export const UPDATE_SHOP_ORDER: any = gql`
  mutation UpdateShopOrder($input: MutationUpdateShopOrderInput!) {
    updateShopOrder(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationUpdateShopOrderSuccess {
        data
      }
    }
  }
`

export const DELETE_SHOP_ORDER: any = gql`
  mutation DeleteShopOrder($input: MutationDeleteShopOrderInput!) {
    deleteShopOrder(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationDeleteShopOrderSuccess {
        data
      }
    }
  }
`

export const RESEND_CONFIRMATION_EMAILS: any = gql`
  mutation ResendConfirmationEmails($input: MutationResendConfirmationEmailsInput!) {
    resendConfirmationEmails(input: $input) {
      __typename
      ... on FieldError {
        field
        message
      }
      ... on MutationResendConfirmationEmailsSuccess {
        data
      }
    }
  }
`

export const GET_LATEST_SHOP_PRODUCTS: any = gql`
  query ShopProductsLatest($input: QueryShopProductsLatestInput!) {
    shopProductsLatest(input: $input) {
      id
      name
      price
      images
      category
    }
  }
`